const translations = {
    make: 'Make',
    model: 'Model',
    nickname: 'Nickname',
    registrationNumber: 'FAA Registration Number',
    uas: 'UAS ({{selectNumber}})'
};

export default translations;
